import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { SetTranslateService } from '../../../core/helper/translatables';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { LanguageService } from '../../../core/service/language.service';
import { B2CSubscription } from '../../model/b2c/b2c-subscription';
import { B2CSubscriptionIdentity } from '../../model/b2c/b2c-subscription-identity';
import { InvoiceDeliveryMethod } from '../../model/const/enum';

export interface IB2CToggleResult {
  leaseAgreementId: string;
  deliveryMethod: InvoiceDeliveryMethod;
}

@Injectable()
export class B2CSubscriptionService extends DataService<B2CSubscription> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService,
    private _languageService: LanguageService
  ) {
    super(client, config, messageService, B2CSubscription, progressBar, 'b2c-subscriptions');
  }

  protected createModel(modelData: any): B2CSubscription {
    const model = B2CSubscription.Map(modelData);
    SetTranslateService(model, this._languageService);
    return model;
  }

  //getFilterDefinition(): Observable<{
  //  caption: string, selectedFields: string[]
  //}> {
  //  return this.client.get<any>(`${this.endpoint}/filter`).pipe(
  //    map(res => {
  //      return {
  //        caption: res.caption ? res.caption : '',
  //        selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : ['caption']
  //      }
  //    }),
  //    catchError(error => { console.log(error); return []; }),);
  //}
}
